import React, { useContext } from "react";
import { SectionIndicatorContext } from "../shared/contexts/SectionIndicatorContext";
import { Box, Typography } from "@mui/material";

/**
 * Controls sections(pages) of a reg process
 * EMAIL-FLOW
 * sectionNumber 1 - EmailVerification
 * sectionNumber 2 - EmailSuccess
 * PHONE-FLOW
 * sectionNumber 3 - PhoneVerificaton
 * sectionNumber 4 - PhoneEmailVerification
 * PASSWORD
 * sectionNumber 5 - optional - AccountSelect (if only one account this wont render)
 * sectionNumber 6 - SetPassword
 * sectionNumber 7 - SetPasswordSuccess

 */

const SectionIndicator = () => {
    const { sectionNumber } = useContext(SectionIndicatorContext);

    const pagesToHideIndicator = [0, 1, 2];

    function indicatorNumberMapper(): number | null {
        switch (sectionNumber) {
            case 3:
                return 1;
            case 4:
                return 2;
            case 5:
                return 3;
            case 6:
                return 3;
        }
        return null;
    }

    const RenderSteps = () => {
        const boxes = [];
        const activeStep = indicatorNumberMapper() || 1;

        for (let i = 0; i < 3; i++) {
            const isDone = i < activeStep;
            const boxStyle = isDone ? { backgroundColor: "primary.main" } : { backgroundColor: "#D3D3D7" };

            boxes.push(<Box key={i} sx={{ height: "4px", flexGrow: 1, ...boxStyle }}></Box>);
        }

        return <>{boxes}</>;
    };

    return (
        <Box hidden={pagesToHideIndicator.includes(sectionNumber as number)}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", paddingBottom: "12px" }}>
                <Typography sx={{ color: "primary.main", fontWeight: 500 }} variant="body1">
                    Krok {indicatorNumberMapper() + "/" + 3}{" "}
                </Typography>
            </Box>

            <Box sx={{ display: "flex", gap: "4px" }}>{RenderSteps()}</Box>
        </Box>
    );
};

export default SectionIndicator;
